<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Spring is Sprung</h1>
<p class="BOD2">Add one of these pretty motifs to a basket, jacket lapel or hat to put a spring in your step.</p>
<p class="IMAGE"><img alt="" src="images/C1-11.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-12.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-6.vue?61ded140